import React from 'react';
import TaskDefault from './TaskSwitch/TaskDefault';

function TaskSwitch(props) {
  const {
    taskID, type,
  } = props;

  switch (type) {
    default:
      return (
        <TaskDefault
          taskID={taskID}
        />
      );
  }
}

export default React.memo(TaskSwitch);
